import reducer from './reducers';
import * as sixthAnalysesActions from './actions';
import * as sixthAnalysesSelectors from './selectors';

export { sixthAnalysesActions, sixthAnalysesSelectors };
export default reducer;